export const FETCH_USER_NOTES = 'FETCH_USER_NOTES'
export const FETCH_USER_NOTES_PENDING = 'FETCH_USER_NOTES_PENDING'
export const FETCH_USER_NOTES_REJECTED = 'FETCH_USER_NOTES_REJECTED'
export const FETCH_USER_NOTES_FULFILLED = 'FETCH_USER_NOTES_FULFILLED'
